
import { dateFormat, directUploadFile } from "@/utils/util";
import { getFileToken } from "../../../../api/user";
import { defineComponent, reactive, toRefs } from "vue";
import { RecordType } from "./updateRecordType";
import { ImagePreview, Notify, Toast } from "vant";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
import { Router, useRoute, useRouter } from "vue-router";
import {
  delRecordApi,
  getRecordApi,
  saveRecordApi,
  updateRecordApi,
} from "../../../../api/farming";
import mitt from "@/utils/mitt";

import { getLandFilterData } from "../../../../api/farmer";

const imgTypeList = ["image/jpeg", "image/png", "image/jpg", "image/gif"];

function getState(): RecordType {
  return {
    isCircle:true,
    dataInfo: {},
    fileList: [],
    uploadFileType: 0, // 0 图片 1 视频 3 其他文件。 默认传图片
    uploadFileCount: 9, // 图片最多九张，视频最多1一个
    message: "",
    accept: "image/*",
    showUploadWay: false,
    isUpload: false,
    previewVideos: false,
    minDate: new Date(1900, 0, 1),
    maxDate: new Date(
      dateFormat().YYYY,
      Number(dateFormat().MM) - 1,
      Number(dateFormat().DD)
    ),
    showWorkDate: false,
    workDate: new Date(
      dateFormat().YYYY,
      Number(dateFormat().MM) - 1,
      Number(dateFormat().DD)
    ),
    sourceId: "",
    sourceLandList: [],
    selectedLandName: "",
    selectedLandId: "",
    landIndex: 0,
    showLandModal: false,
    isDisabled: false, // 在连续点击保存时，会多次请求数据，所以加一个状态，用于限制这种情况
  };
}
// 数据状态 status: 0 待操作 1 已操作(已完成) 2 已忽略
export default defineComponent({
  components: {
    PreviewVideo,
  },
  setup() {
    const state = reactive<RecordType>(getState());
    const route = useRoute();
    const router = useRouter();
    const { saveRecordData, getRecordData, updateRecordData, getLandList } =
      useDatas(state, router);

    if (route.query.item) {
      state.dataInfo = JSON.parse(route.query.item as string);
      state.dataInfo.workTime =
        dateFormat().YYYY + "-" + dateFormat().MM + "-" + dateFormat().DD;
      // 状态为1是已完成的数据，也就是带了id的，所以通过这个id去拿数据回填
      if (+state.dataInfo.status === 1) {
        getRecordData(state.dataInfo.optionRecordId);
      }
    }
    if (route.query.sourceId) {
      state.sourceId = route.query.sourceId as string;
      state.dataInfo.workTime =
        dateFormat().YYYY + "-" + dateFormat().MM + "-" + dateFormat().DD;
      // 获取地块列表
      getLandList();
    }

    // 点击保存
    const onSave = function () {
      if (state.isDisabled) {
        return;
      }
      if(!state.message.trim()&&state.fileList.length===0){
        Notify({ type:"warning", message:"内容和文件至少填写一个。" })
        return
      }
      let tempData = state.dataInfo;
      let videoIds = "";
      let imageIds = "";
      if (state.uploadFileType === 0) {
        imageIds = state.fileList.map((item) => item.id).join(",");
      } else {
        videoIds = state.fileList.map((item) => item.id).join(",");
      }
      // optionId的传递分为几种情况，直接新增记录时没有记录id，所以option传
      let tempOption = tempData.optionId || tempData.id;
      let optionId = tempData.farmingType ? tempOption : "";
      // 有optionId的情况下就不传递areaId
      let areaId = optionId ? "" : tempData.areaId || state.selectedLandId || "";

      let params: any = {
        areaId,
        farmingName: tempData.plantFarmingName || tempData.farmingName,
        farmingType: tempData.farmingType,
        imageIds,
        optionId: tempData.farmingType ? optionId : "",
        remark: state.message,
        videoIds,
        workTime: tempData.workTime,
        isCircle:state.isCircle?1:0
      };
      // 请求发出之后设置按钮不准点击
      state.isDisabled = true;
      // 当记录id存在时说明是记录过的，直接编辑
      if (state.dataInfo.optionRecordId) {
        params.id = state.dataInfo.optionRecordId;
        updateRecordData(params);
      } else {
        saveRecordData(params);
      }
    };

    return {
      ...toRefs(state),
      ...useUpdate(state),
      ...useEvent(state),
      onSave,
    };
  },
});

/**
 * 接口相关
 */
const useDatas = (state: any, router: Router) => {
  return {
    getLandList: async function () {
      // 获取地块
      const result: any = await getLandFilterData({ sourceId: state.sourceId });
      if (result.data.code == 0) {
        // 备份一个text用于组件展示
        state.sourceLandList = result.data.data.map((item: any) => {
          item.text = item.code + item.areaName;
          return item;
        });
        // 获取弹出框默认选中的地块下标用于组件回填
        state.landIndex = state.sourceLandList.findIndex((item: any) => {
          return item.code == state.selectedLandName;
        });
        // 新增记录时，默认填第一个地块
        if (state.sourceLandList.length) {
          state.dataInfo.areaCode = state.sourceLandList[0].code;
          state.dataInfo.areaName = state.sourceLandList[0].areaName;
          state.selectedLandId = state.sourceLandList[0].id;
        }
        // let tempList = state.sourceLandList.filter((item: any) => {
        //   return item.code == state.selectedLandName;
        // });
        // // 回填的数据优先展示 没有数据回填时 默认选中第一个
        // if (tempList.length > 0) {
        //   state.selectedLandId = tempList[0].id;
        //   state.selectedLandName = tempList[0].code;
        // } else if (state.sourceLandList[0]) {
        //   state.selectedLandId = state.sourceLandList[0].id;
        //   state.selectedLandName = state.sourceLandList[0].code;
        // }
      }
    },
    updateRecordData: async function (params: object): Promise<void> {
      const result: any = await updateRecordApi(params);
      if (result.data.code === 0) {
        Notify({ type: "success", message: "保存成功" });
        const timer = setTimeout(() => {
          clearTimeout(timer);
          mitt.emit("recordUpdate");

          router.back();
          state.isDisabled = false
        }, 1000);
      } else {
        state.isDisabled = false
      }
    },
    saveRecordData: async function (params: object): Promise<void> {
      const result: any = await saveRecordApi(params);
      if (result.data.code === 0) {
        Notify({
          type: "success",
          message: "保存成功",
        });
        const timer = setTimeout(() => {
          clearTimeout(timer);
          mitt.emit("recordUpdate");
          router.back();
          state.isDisabled = false;
        }, 1000);
      } else {
        state.isDisabled = false;
      }
    },
    getRecordData: async function (id: string): Promise<void> {
      const result: any = await getRecordApi(id);
      if (result.data.code === 0) {
        let datas = result.data.data;
        Object.assign(state.dataInfo, datas);
        state.message = datas.remark;
        state.isCircle =  datas.isCircle==0?false:true;
        // 重新给干活时间赋值
        state.workDate = new Date(state.dataInfo.workTime);
        if (datas.images.length > 0) {
          state.fileList = datas.images.map((item: any) => {
            item.poster = item.url;
            item.progress = 100;
            return item;
          });
          state.isUpload = true;
          state.uploadFileType = 0;
          state.uploadFileCount = 9;
          state.accept = "image/*";
        } else if (datas.videos.length > 0) {
          state.fileList = datas.videos.map((item: any) => {
            item.poster = item.coverImg;
            item.progress = 100;
            return item;
          });
          state.isUpload = true;
          state.uploadFileCount = 1;
          state.uploadFileType = 1;
          state.accept = "video/*";
        }
      }
    },
  };
};

const useUpdate = (state: any) => {
  const switchChange = (value: any)=>{
    console.log(value);
    state.isCircle = value
  }
  const { uploadVideoFile } = useOper(state);
  return {
    onSelectDate: function () {
      state.showWorkDate = true;
    },
    afterUpload: async (e: any) => {
      if (Array.isArray(e)) {
        e.forEach(async (item) => {
          uploadVideoFile(item);
        });
      } else {
        uploadVideoFile(e);
      }
    },
    onBeforeUpload: function (e: any) {
      // 是图片类型的情况下不用判断时常。
      let isArr = Array.isArray(e);
      if (+state.uploadFileType === 0) {
        if (imgTypeList.indexOf(isArr ? e[0].type : e.type) !== -1) {
          return Promise.resolve();
        }
      }

      // 判断视频大小
      if (+state.uploadFileType === 1) {
        return new Promise<void>((resolve, reject) => {
          let audio = new Audio(URL.createObjectURL(e));
          audio.muted = true;
          audio.play().then(() => audio.pause());
          // 元数据已加载
          audio.addEventListener("loadedmetadata", function (e) {
            let duration = audio.duration;
            if (duration < 2) {
              Toast("视频时长不得小于2秒");
              reject();
            } else {
              resolve();
            }
          });
        });
      }
    },
    switchChange 
  };
};

const useOper = (state: any) => {
  return {
    uploadVideoFile: async function (item: any) {
      const result: any = await getFileToken({
        bucket: "xfarmer",
        fileType: state.uploadFileType,
        type: 2,
        token: localStorage.getItem("token"),
      });
      if (result.data.code == 0) {
        directUploadFile(item, result.data, {
          userType: "2",
          fileType: state.uploadFileType.toString(),
        });
      }
    },
  };
};

const useEvent = (state: any) => {
  return {
    onLandConfirm: function (e: any) {
      state.dataInfo.areaCode = e.code;
      state.dataInfo.areaName = e.areaName;
      state.selectedLandId = e.id;
      state.showLandModal = false;
    },
    onLandCancel: function () {
      state.showLandModal = false;
    },
    onSelectLand: function () {
      // 不是新增或者有农事任务不准选地块
      if (state.dataInfo.farmingType) {
        return;
      }
      state.showLandModal = true;
    },
    onWorkCancel: function () {
      state.showWorkDate = false;
    },
    onWorkConfirm: function (e: Date) {
      let date = dateFormat(new Date(e).getTime());
      state.dataInfo.workTime = date.YYYY + "-" + date.MM + "-" + date.DD;

      state.showWorkDate = false;
    },
    onSelectWay: function (e: any) {
      state.uploadFileType = e.id;
      if (e.id == 0) {
        state.accept = "image/*";
        state.uploadFileCount = 9;
      } else if (e.id == 1) {
        state.accept = "video/*";
        state.uploadFileCount = 1;
      }
      state.isUpload = true;
      state.showUploadWay = false;
    },
    onClickUpload: function () {
      state.showUploadWay = true;
    },
    onDeleteFile: function (e: any) {
      const index = state.fileList.findIndex((item:any) => item.id === e.id);
      if (index !== -1) {
        state.fileList.splice(index, 1);
      }
    },
    onShowFile: function (e: any) {
      // 图片类型
      if (state.uploadFileType === 0) {
        const index = state.fileList.findIndex((item:any) => item.id === e.id);
        ImagePreview({
          images: state.fileList.map((item:any) => item.url),
          startPosition: index === -1 ? 0 : index,
        });
      } else if (state.uploadFileType === 1) {
        state.previewVideos = true;
      }
    },
  };
};
